import request from './base'

export const carList = (params) => {
    return request.post("/admin/v1/car/list", params)
}

export const carAdd = (params) => {
    return request.post("/admin/v1/car/add", params)
}

export const carModify = (params) => {
    return request.post("/admin/v1/car/modify", params)
}

export const carDelete = (params) => {
    return request.post("/admin/v1/car/delete", params)
}

export const carSelect = () => {
    return request.post("/admin/v1/car/select")
}

export const getCarInfo = (params) => {
    return request.post("/admin/v1/car/info", params)
}

export const getCarDetails = (params) => {
    return request.post("/admin/v1/car/details", params)
}
export const getRealTimeCarInfo = (params) => {
    return request.post("/admin/v1/car/realTimeInfo", params)
}

export const getCompanyCarList = (params) => {
    return request.post("/admin/v1/car/companyCarList", params)
}

export const getCarChart = (params) => {
    return request.post("/admin/v1/car/chart", params)
}

export const getCarCharts = (params) => {
    return request.post("/admin/v1/car/charts", params)
}

export const searchCarbyVin = (params) => {
    return request.post("/admin/v1/car/searchCarbyVin", params)
}

export const searchCarbyVin2 = (params) => {
    return request.post("/admin/v1/car/searchCarbyVin2", params)
}

export const carExportAll = () => {
    return request.post("/admin/v1/car/exportAll")
}



// WEBPACK FOOTER //
// ./src/api/car.js